// src/utils/validators.js
export const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

export const validatePhone = (phone) => {
    // US phone format validation
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return phoneRegex.test(phone);
};

export const formatPhoneNumber = (phone) => {
    // Format phone number to (123) 456-7890
    const cleaned = phone.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
};

export const validateTime = (timeObj) => {
    if (!timeObj || !timeObj.hour || !timeObj.minute || !timeObj.ampm) {
        return false;
    }

    const hour = parseInt(timeObj.hour, 10);
    const minute = parseInt(timeObj.minute, 10);

    return hour >= 1 && hour <= 12 && minute >= 0 && minute <= 59;
};

export const convertTo24Hour = (hour, ampm) => {
    let hour24 = parseInt(hour, 10);

    if (ampm === 'PM' && hour24 !== 12) {
        hour24 += 12;
    } else if (ampm === 'AM' && hour24 === 12) {
        hour24 = 0;
    }

    return hour24.toString().padStart(2, '0');
};